module.exports = __webpack_public_path__ + "img/bayreuth_schloss.b90d782d.jpg";